import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, SpinnerLoader } from "@activecollab/components";
import PropTypes from "prop-types";
import StripeCardFormProvider from "~/components/Subscription/BillingPaymentMethod/StripeCardFormProvider";

const AddStripeCardDialog = ({ open, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [isValid, setIsValid] = useState(false);

  const startLoader = useCallback(() => {
    setTimeout(() => {
      setIsLoading(true);
    }, 0);
  }, []);

  const onError = useCallback(() => {
    setIsLoading(false);
  }, []);

  const isValidated = useCallback((e) => {
    setIsValid(e);
  }, []);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      data-testid="dialog"
    >
      <Dialog.Title data-testid="dialogTitle">{t("Change Payment Method")}</Dialog.Title>
      <Dialog.ContentDivider />
      <Dialog.Content data-testid="dialogContent">
        <div data-testid="stripeCardFormProvider">
          <StripeCardFormProvider
            onSubmit={onSubmit}
            onError={onError}
            isValidated={isValidated}
          />
        </div>
      </Dialog.Content>
      <Dialog.ContentDivider />
      <Dialog.Actions
        data-testid="dialogActions"
        className="tw-flex tw-flex-col md:tw-flex-row tw-gap-3"
      >
        {!isLoading ? (
          <>
            <Button
              variant="primary"
              className="tw-mr-3"
              type="submit"
              form="stripe_form"
              onClick={startLoader}
              disabled={!isValid}
              data-testid="submitButton"
            >
              {t("Change Payment Method")}
            </Button>
            <Button
              variant="secondary"
              data-action="cancel"
              onClick={onClose}
              data-testid="cancelButton"
            >
              {t("Cancel")}
            </Button>
          </>
        ) : (
          <div
            className="tw-flex"
            data-testid="spinnerDiv"
          >
            <SpinnerLoader />
            <span className="tw-ml-2">{t("Updating payment method ...")}</span>
          </div>
        )}
      </Dialog.Actions>
    </Dialog>
  );
};

AddStripeCardDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default AddStripeCardDialog;
